module.exports = __webpack_public_path__ + "static/media/arrowRight.edcc3ed0.svg";